export default __webpack_public_path__ + "7b19f4001ed26813a012e3463100434e.svg";